import React, { useContext, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { defaultToastOptions, extractError } from "../../../utils/misc";
import { AppContext } from "../../../context/app";
import AppointmentCreditsHeader from "./AppointmentCreditsHeader";
import AppointmentsTab from "./AppointmentsTab";
import CreditsTab from "./CreditsTab";
import {
  useGetMemberQuery,
  useGetUserAppointmentCreditHistoryQuery,
  useGetUserAppointmentHistoryQuery,
} from "./AppointmentCredits-generated.hooks";

function AppointmentCredits() {
  const { id: memberId }: { id: string } = useParams();

  const { client } = useContext(AppContext);

  const [activeTab, setActiveTab] = useState(0);

  const { data: { getProfile: profile } = {} } = useGetMemberQuery({
    variables: {
      clientUuid: client.uuid,
      userUuid: memberId,
    },
    onError(error) {
      toast.error(extractError(error), defaultToastOptions);
    },
  });

  const {
    data: { getUserAppointmentCreditHistory: credits = [] } = {},
    refetch: refetchCredits,
    loading: creditsLoading,
  } = useGetUserAppointmentCreditHistoryQuery({
    variables: {
      userUuid: memberId,
    },
    onError(error) {
      toast.error(extractError(error), defaultToastOptions);
    },
  });

  const {
    data: { getUserAppointmentHistory: appointmentHistory = [] } = {},
    refetch: refetchHistory,
    loading,
  } = useGetUserAppointmentHistoryQuery({
    variables: {
      userUuid: memberId,
    },
    onError(error) {
      toast.error(extractError(error), defaultToastOptions);
    },
  });

  const creditsStyle = { display: activeTab === 0 ? "block" : "none" };

  const appointmentsStyles = { display: activeTab === 1 ? "block" : "none" };

  return (
    <div>
      <AppointmentCreditsHeader
        memberId={memberId}
        profile={profile}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        onCreditsSuccess={refetchCredits}
        onBookingSuccess={refetchHistory}
      />
      <div className="mt-4">
        <div style={creditsStyle}>
          <CreditsTab
            memberId={memberId}
            data={credits}
            loading={creditsLoading}
            refetch={refetchCredits}
          />
        </div>
        <div style={appointmentsStyles}>
          <AppointmentsTab
            data={appointmentHistory}
            loading={loading}
            onRefetch={refetchHistory}
          />
        </div>
      </div>
    </div>
  );
}

export default AppointmentCredits;
